/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Propopular1Inputs */

const zh_pricing_propopular1 = /** @type {(inputs: Pricing_Propopular1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最受欢迎`)
};

const en_pricing_propopular1 = /** @type {(inputs: Pricing_Propopular1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Popular`)
};

const es_pricing_propopular1 = /** @type {(inputs: Pricing_Propopular1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más Popular`)
};

/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Pricing_Propopular1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_propopular1 = /** @type {((inputs?: Pricing_Propopular1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Propopular1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_propopular1(inputs)
	if (locale === "en") return en_pricing_propopular1(inputs)
	return es_pricing_propopular1(inputs)
});
export { pricing_propopular1 as "pricing_proPopular" }